import React, { useState } from 'react';
import { getService } from '@Client/runner.hooks/useService';
import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';
import { MaintenanceUserDetailModal } from './MaintenanceUserDetailModal';
import { IUserSummary } from '@Shared.Angular/@types/core/contracts/queryModel/user/userSummary';
import IconButton from '@Shared.Angular/flowingly.components/buttons/IconButton';

type Props = {
  user: IUserSummary;
  onUserUpdated: () => void;
};

export const MaintenanceUserListActions = ({ user, onUserUpdated }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const permissionsService = getService('permissionsService');

  const hasActionsPermission = permissionsService.currentUserHasAnyOfPermissions(
    [
      FlowinglyPermissions.ADMIN_ACTIONS,
      FlowinglyPermissions.ADMIN_ACTIONS_USER
    ]
  );

  const editUser = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = (updated: boolean) => {
    setIsModalOpen(false);
    if (updated) {
      onUserUpdated();
    }
  };

  return (
    <>
      <div className="list-actions">
        {hasActionsPermission && (
          <span
            onClick={editUser}
            title="Edit User"
            className="list-actions__action"
          >
            <IconButton iconClass='fa-pencil' title='Edit User' onClick={editUser} />
          </span>
        )}
      </div>
      {isModalOpen && (
        <MaintenanceUserDetailModal user={user} onClose={handleModalClose} />
      )}
    </>
  );
};
